import { useIntl } from 'react-intl'
import StepHeading from 'components/global/StepHeading'
import Box from 'components/shared/Box'
import ContactData from './sections/ContactData'
import Agreements from './sections/Agreements'
import PlaceOrderSection from './sections/PlaceOrderSection'
import CreateAccount from './sections/CreateAccount'
import GDPRClause from 'components/global/GDPRClause'
import { useEffect, useRef } from 'react'
import { useCart } from 'store/cart-slice/hooks'
import { useApp } from 'store/steps'
import { useGetUserSessionQuery } from 'store/auth-slice/hooks'
import { creatorAccommodationFirstStep, firstStep } from 'routes/basenames'
import {
    calculateAccommodationAddToCartEvent,
    pushDataLayer,
} from 'helpers/analytics'
import { useAppSelector } from 'store/hooks'

const PlaceOrder = () => {
    const { formatMessage } = useIntl()
    const analyticsRef = useRef(false)
    const { refetchCart, isCartEmpty, isCartFetching } = useCart()
    const { language, isCreatorAccommodation } = useApp()
    const { data: userSession } = useGetUserSessionQuery({
        _locale: language,
    })

    const { accommodation, accommodationDetails } = useAppSelector(
        (state) => state.cart.items
    )
    const { isAssignGuestsVisible } = useAppSelector(
        (state) => state.accommodation
    )

    const calculatedFirstStep = isCreatorAccommodation
        ? creatorAccommodationFirstStep
        : firstStep

    // < analytics
    useEffect(() => {
        if (
            !isCreatorAccommodation &&
            isAssignGuestsVisible &&
            accommodation &&
            accommodationDetails
        ) {
            if (!analyticsRef.current) {
                const accommodationAddToCartEvent =
                    calculateAccommodationAddToCartEvent(accommodation)
                pushDataLayer(accommodationAddToCartEvent)
                analyticsRef.current = true
            }
        }
    }, [isAssignGuestsVisible, accommodation, accommodationDetails])
    // analytics >

    useEffect(() => {
        !isCartFetching && refetchCart()

        // < analytics
        pushDataLayer({
            event: 'funnelStep',
            event_category: !isCreatorAccommodation
                ? 'tickets'
                : 'accommodation',
            event_action: 'checkout_form_presented',
            event_label: '',
        })
        // analytics >
    }, [])

    useEffect(() => {
        if (isCartFetching) return

        if (isCartEmpty) window.location.href = calculatedFirstStep
    }, [isCartEmpty])

    return (
        <Box gap={[16, 24]} align="stretch">
            <StepHeading
                title={formatMessage({
                    id: 'global.steps.caption_order',
                    defaultMessage: 'Zamówienie i płatność',
                })}
            />
            <ContactData />
            {!userSession && <CreateAccount />}
            <Agreements />
            <PlaceOrderSection />
            <GDPRClause />
        </Box>
    )
}

export default PlaceOrder
